import {DocumentWrapper} from "@/models/ai/documentWrapper.model";


export class AiSpeachGenerationFile{
 uid:string;
 jobID:string;
 name:string;
 progress:number;
 data:DocumentWrapper|null=null;
 constructor(uid:string,jobID:string,name:string,data:DocumentWrapper) {
   this.uid=uid;
   this.jobID=jobID;
   this.name=name;
   this.data=data;
   this.progress=0;
 }
}

export class DocumentRef {
  documentIndex!: number;
  pages!: number[];
}

export class Role {
  id!: string;
  title!: string;
  description!: string;
  isCustom?: boolean;
}

export class SuggestedScenario {
  id!: string;
  title!: string;
  description!: string;
  documentRefs?: DocumentRef[];
}

export class RolesResult {
  roles: Role[] = [];
}

export class ScenariosResult {
  scenarios: SuggestedScenario[] = [];
}

export type PickerMode = 'ALL_CONTENT' | 'SYNTHESIS' | 'COMPARISON' | 'ROLE';

export interface ModePickerPayload {
  mode: PickerMode;
  oldDocumentJobID?: string;
  newDocumentJobID?: string;
}
